export default __webpack_public_path__ + "static/media/yoga.576fa1a5.jpeg";